export const countryOption = [
  {key: '1', value: 'US', labels: 'United States'},
  // 国追加によってリストの修正を行う
  // 現時点アメリカのみ
  // {key: '2', value: 'KR', labels: 'Korea'},
]
